import {DefaultSettings, settings} from "../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../wireup/AlmeState";
import {Message} from "../../../types/response";
import {AlmeResponseV5} from "@alme/types/response/AlmeResponse";
import {displayCallToActionButtons, disableCallToActionButtons} from "./actions/Actions";
import {DisableCallToActionResponseAction} from "./models/CallToActionResponseActions";

export default class ResponseHandlerCallToAction
{
    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;

    constructor(passedSettings: DefaultSettings = settings)
    {
        this._settings = passedSettings;
    }

    static getDefaultSettings(): DefaultSettings
    {
        return settings;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getReducer()
    {
        return (state = defaultState): AlmeState => state;
    }

    process(message: Message): Message
    {
        message.response = Array.isArray(message.response) ?
            message.response.map(response => this.processResponse(response)) :
            this.processResponse(message.response as AlmeResponseV5);

        return message;
    }

    processResponse(response: AlmeResponseV5): AlmeResponseV5 {

        const {callToActionResponseActionName, disableCallToActionResponseActionName} = this._settings.responseActionConstants;

        const ctaResponseAction = response?.responseActions?.find(action => action.Name === callToActionResponseActionName);
        const disableAction = response?.responseActions?.find(action => action.Name === disableCallToActionResponseActionName);
        const entryId = response?.extensionData?.entryId as string;

        if (ctaResponseAction && entryId)
        {
            this._store?.dispatch(displayCallToActionButtons(entryId));
        }

        if (disableAction)
        {
            this._store?.dispatch(disableCallToActionButtons((disableAction as DisableCallToActionResponseAction).entryId));
        }

        return response;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/message-renderer-call-to-action/src/response-handler-call-to-action.ts